import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showStad, setShowStad] = useState(false);
  const [showTradgard, setShowTradgard] = useState(false);

  const stadRef = useRef(null);
  const tradgardRef = useRef(null);

  // Stänger alla menyer
  function closeMenus() {
    setMenuOpen(false);
    setShowStad(false);
    setShowTradgard(false);
  }

  // Klick utanför stänger dropdowns
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        stadRef.current && !stadRef.current.contains(event.target) &&
        tradgardRef.current && !tradgardRef.current.contains(event.target)
      ) {
        setShowStad(false);
        setShowTradgard(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold text-green-700">
          <Link to="/" onClick={closeMenus}>Provalt Service AB</Link>
        </h1>

        {/* Mobilmeny-knapp */}
        <button
          className="sm:hidden text-green-700"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Navigering */}
        <nav
          className={`sm:flex sm:gap-6 items-center text-xl ${menuOpen ? "block" : "hidden"} sm:block absolute sm:static top-16 left-0 w-full sm:w-auto bg-white sm:bg-transparent shadow-md sm:shadow-none z-50`}
        >
          <div className="flex flex-col sm:flex-row gap-4 p-4 font-semibold text-gray-800 sm:p-0">
            <Link to="/" className="hover:text-green-600" onClick={closeMenus}>Start</Link>

            {/* Städ Dropdown */}
            <div className="relative" ref={stadRef}>
              <button
                className="hover:text-green-600 flex items-center justify-between w-full sm:w-auto"
                onClick={() => {
                  setShowStad(!showStad);
                  setShowTradgard(false);
                }}
              >
                Städ ▾
              </button>
              {showStad && (
                <div className="absolute bg-white shadow-lg rounded-md z-30">
                  <Link to="stad/flyttstadning" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Flyttstädning</Link>
                  <Link to="/stad/fonsterputs" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Fönsterputs</Link>
                  <Link to="/stad/trappstadning" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Trappstädning</Link>
                  <Link to="/stad/kontorsstadning" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Kontorsstädning</Link>
                  <Link to="/stad/byggstadning" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Byggstädning</Link>
                  <Link to="/stad/lokalvard" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Lokalvård</Link>
                </div>
              )}
            </div>

            {/* Trädgård Dropdown */}
            <div className="relative" ref={tradgardRef}>
              <button
                className="hover:text-green-600 flex items-center justify-between w-full sm:w-auto"
                onClick={() => {
                  setShowTradgard(!showTradgard);
                  setShowStad(false);
                }}
              >
                Trädgård ▾
              </button>
              {showTradgard && (
                <div className="absolute bg-white shadow-lg rounded-md z-30">
                  <Link to="/tradgard/tradgardsskotsel" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Trädgårdsskötsel</Link>
                  <Link to="/tradgard/plantering" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Plantering</Link>
                  <Link to="/tradgard/lovblasning" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Lövblåsning</Link>
                  <Link to="/tradgard/vinterunderhall" className="block px-4 py-2 hover:bg-gray-100" onClick={closeMenus}>Vinterunderhall</Link>
                </div>
              )}
            </div>

            <Link to="/om-oss" className="hover:text-green-600" onClick={closeMenus}>Om Oss</Link>
            <Link to="/kontakt" className="hover:text-green-600" onClick={closeMenus}>Kontakt</Link>
          </div>
        </nav>
      </div>
    </header>
  );
}
